module.exports = __webpack_public_path__ + "static/img/2_index_3.1f2e208.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dist/products/2_index_3.jpg
// module id = 5SNJ
// module chunks = 1